// removed by extract-text-webpack-plugin
module.exports = {"meta":"\"{}\""};